import { createClient } from '@sanity/client'

export const client = createClient({
    projectId: '5ij5zx7i', // find this at manage.sanity.io or in your sanity.json
    dataset: "production", // this is from those question during 'sanity init'
    useCdn: true,

    apiVersion: '2023-07-03',
})